import { WorkSchema, type Work } from './document';
import { migrateDocument } from './migrations';

/** 编辑器打开 / 服务端保存 / 发布任务用：迁移 + 校验，返回最新版文档。 */
export function loadWork(raw: unknown): Work {
  if (typeof raw !== 'object' || raw === null) throw new Error('文档不是对象');
  const migrated = migrateDocument(raw as Record<string, unknown>);
  return WorkSchema.parse(migrated);
}

/** 运行时用：只校验，不迁移。文档应当已经是最新版。 */
export function parseWork(raw: unknown): Work {
  return WorkSchema.parse(raw);
}

export function safeParseWork(raw: unknown) {
  return WorkSchema.safeParse(raw);
}
